import React from 'react';
import { ReactNode } from 'react';

import MainLayout from './main';

export interface IBasicLayoutProps {
  children: ReactNode;
}

export type LayoutTypesProps = IBasicLayoutProps;

export function layoutTypes({ children, ...props }: IBasicLayoutProps) {
  return {
    main: <MainLayout {...props}>{children}</MainLayout>,
  };
}
